<template>
  <div class="search-container">
    <div class="search-tabs">
      <div
        class="search-tab"
        v-for="item in options"
        :key="item.value"
        :class="{ active: value === item.value, disabled: !!item.disabled }"
        @click="searchChange(item.value, !!item.disabled)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    newEvgSkuCode: { type: String, default: '' },
  },
  computed: {
    options() {
      return [
        {
          label: this.$l('INDEX.tab_pane_label_evg_skuBase') || '基本信息',
          value: 'BASE',
        },
        {
          label: this.$l('INDEX.evg_sku_tab_pane_label_SPEC') || '产品规格',
          value: 'SPEC',
          disabled: !this.newEvgSkuCode,
        },
        {
          label: this.$l('INDEX.evg_sku_tab_pane_label_FABRIC') || '面料构成',
          value: 'FABRIC',
          disabled: !this.newEvgSkuCode,
        },
        {
          label: this.$l('INDEX.evg_sku_tab_pane_label_Material') || '辅料构成',
          value: 'Material',
          disabled: !this.newEvgSkuCode,
        },
        {
          label: this.$l('INDEX.tab_lable_evg_sku_fty') || '生产厂家',
          value: 'FTY',
          disabled: !this.newEvgSkuCode,
        },
        {
          label: this.$l('INDEX.evg_sku_tab_pane_label_skuImage') || '产品图片',
          value: 'IMG',
          disabled: !this.newEvgSkuCode,
        },
        {
          label: this.$l('INDEX.evg_sku_tab_pane_label_platform') || '销售渠道',
          value: 'SALE',
          disabled: !this.newEvgSkuCode,
        },
      ]
    },
  },
  methods: {
    searchChange(value, disabled) {
      if (disabled) {
        return
      }
      this.$emit('update:value', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.search-container {
  .search-tabs {
    display: flex;
    align-items: center;
    .search-tab {
      font-size: 14px;
      line-height: 28px;
      padding: 0px 0px 15px 0px;
      margin-right: 45px;
      color: #2e2e2e;
      border-bottom: 3px solid transparent;
      cursor: pointer;
      width: max-content;
      .badge {
        margin-left: 5px;
        font-weight: 400;
        color: #707070;
        background-color: rgba(0, 0, 0, 0.07);
        padding: 3px 7px;
        font-size: 12px;
        border-radius: 10px;
      }
    }
    .search-tab:hover {
      color: #007bff;
      border-bottom-color: rgba(0, 0, 0, 0.1);
    }
    .search-tab.active {
      color: #007bff;
      font-weight: 600;
      border-bottom-color: #007bff;
      .badge {
        font-weight: 600;
      }
    }
    .search-tab.disabled {
      color: #2e2e2e !important;
      border-bottom: 3px solid transparent !important;
      cursor: not-allowed;
    }
  }
}
</style>
